import React from "react";
import { Iconsvg } from "@wk/components-react16";

export const LoadingSpinner = () => {
  return (
    <div className="wk-align-center">
      <Iconsvg name="spinner" isSpin size={32} />
    </div>
  );
}

export default LoadingSpinner;
